import AnalyticsApi from '../../api/AnalyticsApi';
import type { ClickStreamEvent, CustomAttributes, EventSourceContext } from './clickStreamEvent';
import { makeEvent } from './clickStreamEvent';

enum EventSources {
  Redux = 'system',
  UserInteraction = 'user_interaction'
}

const makeEventName = (eventName: string) => `SellToCarvana - ${eventName}`;

const recordMoMetricsEvent = (
  eventSourceContext: EventSourceContext,
  customAttributes: CustomAttributes = {}
): ClickStreamEvent => {
  const event = makeEvent(eventSourceContext, customAttributes);
  AnalyticsApi.queue(event);
  return event;
};

const recordMoMetricsEventImmediately = async (
  eventSourceContext: EventSourceContext,
  customAttributes: CustomAttributes = {}
): Promise<ClickStreamEvent> => {
  const event = makeEvent(eventSourceContext, customAttributes);
  await AnalyticsApi.queueAndSendAll(event);
  return event;
};

export { recordMoMetricsEvent, recordMoMetricsEventImmediately, makeEventName, EventSources };
